import { customAxios } from "./customAxios";

/**
 * 설비(equipId)의 가장 최근 IAQ 진단 결과 1건을 조회합니다.
 * 결과가 없으면 204(No Content)를 반환합니다.
 * @param {*} query 
 * @returns 
 */
export const getAhuIaqLogsLatestByEquipmentId = async(equipId)=>{
  const res = await customAxios.get(`/api/ahu/iaq/logs/result/${equipId}/latest`);
//   console.log(res);
  if (res && res.data) {
      //return Object.values(res.data);
      return res.data;
  }
  return null;
}

/**
 * 설비(equipId)의 IAQ 진단 결과(logs.result)를 page 기반으로 조회합니다. 
 * 정렬 기준: tsBucket desc, resultId desc.
 * @param {*} query 
 * @returns 
 */
export const getAhuIaqLogsByQueryString = async(equipId, query='')=>{
  const res = await customAxios.get(`/api/ahu/iaq/logs/result/${equipId}${query}`);
  //console.log(res);
  if (res && res.data) {
      //return Object.values(res.data);
      return res.data;
  }
  return null;
}
